import { Dispatch } from 'react';
import {
  InsuranceJourneyVehicleDetailsType,
  Modification,
  VehicleType
} from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const VehicleDetailsPageEventHandlers = (
  vehicleInfo: InsuranceJourneyVehicleDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeVrnKnown: (value: boolean, brand: string) => {
      //always reset manual and lookup vehicle details
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: {
          ...vehicleInfo,
          vrnKnown: value,
          userVrn: '',
          manufacturer: brand,
          model: '',
          transmissionType: '',
          fuelType: '',
          numberOfDoors: '',
          vehicleSpecification: '',
          vehicle: undefined
        }
      });
    },

    onChangeUserVrn: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, userVrn: value }
      });
    },

    onChangeManufacturer: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: {
          ...vehicleInfo,
          manufacturer: value,
          vehicleSpecification: '',
          model: ''
        }
      });
    },

    onChangeModel: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, model: value, vehicleSpecification: '' }
      });
    },

    onChangeFuelType: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: {
          ...vehicleInfo,
          fuelType: value,
          vehicleSpecification: ''
        }
      });
    },

    onChangeTransmissionType: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: {
          ...vehicleInfo,
          transmissionType: value,
          vehicleSpecification: ''
        }
      });
    },

    onChangeNumberOfDoors: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: {
          ...vehicleInfo,
          numberOfDoors: value,
          vehicleSpecification: ''
        }
      });
    },

    onChangeIsItNewOrUsed: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, isItNewOrUsed: value }
      });
    },

    onChangeVendor: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, vendor: value }
      });
    },

    onChangeDealer: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, dealer: value }
      });
    },

    onChangeCarvalue: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, carValue: value }
      });
    },

    onChangeYearOfManufacture: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, yearOfManufacture: value }
      });
    },

    onChangeKeysPickupDate: (value: Date | undefined): void => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, keysPickupDate: value }
      });
    },

    onChangeVehicle: (value: VehicleType | undefined): void => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: {
          ...vehicleInfo,
          vehicle: value,
          manufacturer: '',
          model: '',
          transmissionType: '',
          fuelType: '',
          numberOfDoors: '',
          vehicleSpecification: ''
        }
      });
    },

    onChangeHasTrackingDevice: (value: boolean) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, hasTrackingDevice: value }
      });
    },

    onChangeTrackingDevice: (value: string, key?: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: {
          ...vehicleInfo,
          trackingDevice: value,
          trackingDeviceKey: key
        }
      });
    },

    onChangeVehicleHasBeenModified: (value: boolean) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, hasBeenModified: value }
      });
    },

    onUpdateModificationList: (value: Modification[]) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, modifications: [...value] }
      });
    },

    onChangeVehicleSpecification: (value: string) => {
      dispatch({
        type: 'set-vehicle-details',
        vehicleInfo: { ...vehicleInfo, vehicleSpecification: value }
      });
    }
  };
};
